import type { ChakraProps } from '@chakra-ui/react';
import type {
  CdcDepositCardSwapInfo,
  CdcDepositCardTopUpInfo,
} from '@cronos-app/binding-swap-sdk/dist/esm/cdc-deposit-card';
import type { TokenInfo } from '@cronos-app/swap-sdk';
import type { FC } from 'react';

export type ExtendedTokenInfo = Omit<TokenInfo, 'icon'> & {
  Icon?: FC<ChakraProps>;
};

export enum CardView {
  First,
  Second,
}

export enum CdcCardType {
  None,
  First,
  Second,
}

export enum TopUpTab {
  TopUp,
  History,
}

interface BaseInfo {
  fromToken: ExtendedTokenInfo;
  fromAmount: string;
  toToken: ExtendedTokenInfo;
  toAmount: string;
}

export type DirectTopUpInfo = CdcDepositCardTopUpInfo & BaseInfo;

export type SwapInfo = CdcDepositCardSwapInfo &
  BaseInfo & {
    needToSwapFirst: true;
    toMinAmount: string;
    paths: {
      percentage: number;
      path: string[];
    }[];
    slippageTolerance: number;
    priceImpact: number;
    priceImpactExcludeLpFee: number;
    lpFee: string; // in native token
    gasEstimate: string; // in native token
  };
